import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import type Form from 'modules/surveys/store/models/Form'
import QuestionGroup, { IQuestionGroup } from 'modules/surveys/store/models/QuestionGroup'
import type Survey from 'modules/surveys/store/models/v2/Survey'

interface Data {
  form_id: number
  accesses_ids: number[]
  access_group_id?: number
}

export class QuestionGroups extends Collection<QuestionGroup> {
  get cacheKey(): string {
    return 'surveysQuestionGroups'
  }
  constructor(data: IQuestionGroup[] = []) {
    super(data)
    makeObservable(this, {
      answered: computed,
      notAnswered: computed,
    })
  }

  get indexes() {
    return ['created_at', 'end_on', 'target_id']
  }

  model() {
    return QuestionGroup
  }

  get answered(): QuestionGroup[] {
    return this.models.filter((q) => Boolean(q.attributes.answered_at))
  }

  get notAnswered(): QuestionGroup[] {
    return this.models.filter((q) => !q.attributes.answered_at)
  }

  async bulkCreate(data: Data) {
    const value = await this.rpc('bulk_create', data)
    this.add(value)

    return value
  }

  getQuestionGroupsInCycle([createdAt, endOn]: [string, string]): QuestionGroup[] {
    return this.filter({
      created_at: createdAt,
      end_on: endOn,
    })
  }
}

const singleton = new QuestionGroups()

export const surveyQuestionGroups = (form: Form | Survey) => {
  return singleton.filter({
    surveys_form_id: form.attributes.id,
  })
}

export default singleton
